"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    button: (0, _defineProperty2.default)({
      height: 18,
      width: 18,
      cursor: 'pointer',
      border: 0,
      background: 'none',
      padding: 0,
      outline: 'none',
      marginLeft: theme.spacing(1)
    }, theme.breakpoints.down('md'), {
      height: 15,
      width: 15
    }),
    dot: (0, _defineProperty2.default)({
      backgroundColor: theme.palette.grey.A200,
      height: 15,
      width: 15,
      borderRadius: 6,
      margin: 0
    }, theme.breakpoints.down('md'), {
      height: 12,
      width: 12
    }),
    active: {
      backgroundColor: theme.palette.primary.main
    }
  };
}, {
  name: 'SxJumbotronPaginationDot'
});

function PaginationDot(_ref) {
  var active = _ref.active,
      pClasses = _ref.classes,
      className = _ref.className,
      index = _ref.index,
      onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["active", "classes", "className", "index", "onClick"]);
  var classes = useStyles({
    className: className,
    classes: pClasses
  });

  var handleClick = function handleClick(event) {
    onClick(event, index);
  };

  return _react.default.createElement("button", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    type: "button",
    className: classes.button,
    onClick: handleClick
  }), _react.default.createElement("div", {
    className: (0, _clsx.default)(classes.dot, active && classes.active)
  }));
}

PaginationDot.propTypes = {
  active: _propTypes.default.bool.isRequired,
  classes: _propTypes.default.shape({
    active: _propTypes.default.string,
    button: _propTypes.default.string,
    dot: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  index: _propTypes.default.number.isRequired,
  onClick: _propTypes.default.func.isRequired
};
PaginationDot.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = PaginationDot;
exports.default = _default;